/**
 * API Configuration - Centralized API endpoints and configuration
 */

export const API_CONFIG = {
  BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL || 'https://greenfilter-api.codingtier.com',
  TIMEOUT: 30000, // 30 seconds - reasonable timeout for API requests
} as const;

export const API_ENDPOINTS = {
  // Products
  product: '/product',
  products: '/products',
  productSearch: '/products/search',

  // Collections
  collectionProducts: '/collection-products',

  // Makes/Brands
  make: '/make',

  // Global
  globalSettings: '/global-settings',

  // Contact
  contact: '/contact',

  // Warranty
  warrantyRegistration: '/warranty-registration',
} as const;

/**
 * Product Type IDs - Used for filtering products by type
 * These match the database product_types table
 */
export const PRODUCT_TYPE_IDS = {
  AIR_CLEANER: 1,                    // Air Cleaner Assembly
  UNIVERSAL_PANEL: 2,                // Panel Filter
  COLD_AIR_INTAKE: 3,                // Cold Air Intake Kit (not currently used)
  UNIVERSAL_ROUND: 4,                // Round Filter
  ACCESSORY: 5,                      // Accessory (not currently used)
  BASKET_CANISTER: 6,                // Basket/Canister Filter (not currently used)
  UNIVERSAL_CONE_CYLINDER: 7,        // Cone/Cylinder Filter
  CLEANING_KIT: 8,                   // Cleaning Kit
  MOTORCYCLE_ATV: 9,                 // Motorcycle/ATV Filter (not currently used)
  HARLEY_DAVIDSON: 10,               // Harley-Davidson Filter
  THROTTLE_CONTROLLER: 13,           // Throttle Controller
} as const;

/**
 * Helper function to build API URL
 */
export function buildApiUrl(endpoint: string, params?: Record<string, string | number>): string {
  let url = `${API_CONFIG.BASE_URL}${endpoint}`;

  if (params) {
    const queryString = new URLSearchParams(
      Object.entries(params).reduce((acc, [key, value]) => {
        acc[key] = String(value);
        return acc;
      }, {} as Record<string, string>)
    ).toString();

    url += `?${queryString}`;
  }

  return url;
}
